module.exports = __webpack_public_path__ + "static/media/Pina-Colada-Tower-768x628.2fc0e4d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/ourProducts/Pina-Colada-Tower-768x628.png
// module id = 156
// module chunks = 0